module.exports = __webpack_public_path__ + "static/media/map-marker.bdc18263.png";